import React from "react";
import { connect, useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { useHistory } from "react-router";
import { createStructuredSelector } from "reselect";
import { toPersianNum, toSeperatedNum } from "../../assets/utils";
import { clearUser } from "../../redux/user/user.actions";
import { selectUserInfo } from "../../redux/user/user.selectors";
import { socketServer } from "../../assets/socketConnection";
import { setUserCookie } from "../../redux/login/login.actions";
import {
  BadgeStyled,
  ImgStyled,
  ScoresStyled,
  BalanceWallet,
  BalanceWalletToman,
  BalanceWalletText,
  Tooman,
  AmountBalance,
  Icon,
  ImageInputStyled,
} from "./userInfo.styles";
import socket from "../../assets/socketConnection";

const UserInfo = ({ selectUserInfo }) => {
  // console.log(selectUserInfo);
  const dispatch = useDispatch();
  const history = useHistory();

  const {
    firstname,
    lastname,
    account_balance,
    status_persian,
    point_balance,
    profile_img,
  } = selectUserInfo;
  function setCookie(cname, cvalue, exdays) {
    const d = new Date();
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
    let expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }
  const onExitClick = () => {
    dispatch(clearUser());
    setCookie("token", "", -1);
    history.replace("/login");
  };
  const UploadImage = () => {
    console.log("formData");
    const fileInput = document.querySelector(".profile__image");
    const formData = new FormData();
    formData.append("file", fileInput?.files[0]);
    // console.log("formData", fileInput?.files[0]);
    const options = {
      method: "POST",
      body: formData,
    };
    fetch(`${socketServer}upload/profile`, options)
      .then((res) => res.json())
      .then((res) => {
        console.log("formData", res.image_filename);
        socket.emit("set_profile_image", { profile_img: res.image_filename });
      });
  };
  return (
    <div className="mb-4">
      <div className="mb-2">
        {profile_img ? (
          <ImgStyled
            src={`${socketServer}uploaded_profile_images/${profile_img}.jpg`}
            alt="profile image"
          />
        ) : (
          <ImageInputStyled
            className="profile__image"
            accept="image/*"
            name="image"
            onChange={UploadImage}
            type="file"
          />
        )}
      </div>
      <Link to="/app2/user-info">
        <div className="d-flex align-items-center justify-content-between mb-2">
          <div className="font-weight-bold">
            {`${firstname ? firstname : "نام"} ${
              lastname ? lastname : "نام خانوادگی"
            }`}
          </div>
          <BadgeStyled>{status_persian ? status_persian : "..."}</BadgeStyled>
        </div>
      </Link>
      <Link to="/app2/jeton">
        <ScoresStyled className="d-flex align-items-center justify-content-between">
          <div>جمع امتیازات: </div>
          <div>
            {point_balance
              ? toSeperatedNum(toPersianNum(point_balance))
              : "..."}
          </div>
        </ScoresStyled>
      </Link>
      <Link to="/app2/wallet">
        <BalanceWallet>
          <BalanceWalletText>
            <Icon></Icon>
            کیف پول
          </BalanceWalletText>
          <BalanceWalletToman>
            <AmountBalance>
              {account_balance
                ? toSeperatedNum(toPersianNum(account_balance))
                : ""}
              <div className="mr-1">
                {account_balance > 0
                  ? "+"
                  : account_balance === 0
                  ? "..."
                  : "-"}
              </div>
            </AmountBalance>
            {account_balance !== 0 ? <Tooman>تومان</Tooman> : ""}
          </BalanceWalletToman>
        </BalanceWallet>
      </Link>
      <div className="text-left mt-2">
        <button
          onClick={onExitClick}
          className="bg-danger border--4 text-white px-2"
        >
          خروج
        </button>
      </div>
    </div>
  );
};

const mapStateToProps = createStructuredSelector({
  selectUserInfo: selectUserInfo,
});

export default connect(mapStateToProps)(UserInfo);
